import { useState } from 'react';
import { cn } from '@/lib/utils';
import { isHalloweenLogoActive } from '@/lib/halloweenLogo';
import HalloweenBrandLogo from '@/components/common/HalloweenBrandLogo';

export default function BrandLogo({ className = '' }: { className?: string }) {
  const [halloween] = useState(() => isHalloweenLogoActive(Date.now(), window.location.search));

  return (
    <div className={cn('mb-8', className)}>
      <span className="text-lg font-semibold tracking-tight">
        {halloween ? (
          <HalloweenBrandLogo />
        ) : (
          <img src="/assets/logo-white.svg" alt="welya-logo" className="h-[29px] w-auto" />
        )}
      </span>
    </div>
  );
}
